import { authService } from '@/utils/request'
import { service } from '@/services/base-service'

export function login(data) {
  return authService({
    url: '/vue-element-admin/user/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return service.get('/auth/user_info', {
    baseURL: process.env.VUE_APP_AUTH_API || process.env.VUE_APP_BASE_API
  })
}

export function getToken() {
  return authService({
    url: '/auth/token',
    method: 'post',
    withCredentials: true
  })
}

export function refreshToken() {
  return authService({
    url: '/auth/refresh',
    method: 'post',
    withCredentials: true
  })
}
